export enum DsiScoreCategory {
    LOW,
    MODERATE,
    HIGH
}
